import { lazy } from "react";

export const LazyAddRecord = lazy(() => import("../pages/record/AddRecord"));
export const LazyNotes = lazy(() => import("../pages/record/notes/Notes"));
